import { useContext } from 'react';
import { createNamedContext } from '@utils';
import { BadgeNotificationsContextValue } from './interfaces';

export const BadgeNotificationsContext = createNamedContext<BadgeNotificationsContextValue | undefined>(undefined, 'BadgeNotifications.Context');

export const useBadgeNotificationStats = () => useContext(BadgeNotificationsContext);